/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Emailplaceholder1Inputs */

const he_auth_login_emailplaceholder1 = /** @type {(inputs: Auth_Login_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const en_auth_login_emailplaceholder1 = /** @type {(inputs: Auth_Login_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Auth_Login_Emailplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_login_emailplaceholder1 = /** @type {((inputs?: Auth_Login_Emailplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Emailplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_login_emailplaceholder1(inputs)
	return en_auth_login_emailplaceholder1(inputs)
});
export { auth_login_emailplaceholder1 as "auth_login_emailPlaceholder" }